// src/MessageInput.js
import React, { useState } from 'react';

function MessageInput({ onSendMessage, currentUser }) { // Mottar en funksjon for å sende melding, og hvem som er aktiv
  const [inputText, setInputText] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault(); // Forhindre at skjemaet sender og laster siden på nytt
    if (inputText.trim() === '') return; // Ikke send tomme meldinger

    onSendMessage(inputText, currentUser); // Kall funksjonen fra ChatDialog
    setInputText(''); // Tøm input-feltet
  };

  return (
    <form onSubmit={handleSubmit} className="message-input-form" style={{marginTop: '20px', display: 'flex'}}>
      <input
        type="text"
        value={inputText}
        onChange={(e) => setInputText(e.target.value)}
        placeholder={`Skriv som ${currentUser}...`}
        style={{flexGrow: 1, padding: '10px', marginRight: '10px'}}
      />
      <button type="submit" style={{padding: '10px'}}>Send</button>
    </form>
  );
}

export default MessageInput;